// src/components/NetworkIndicator.js
import React, { useState, useEffect } from 'react';
import { NETWORK_CONFIG, requestNetworkSwitch } from '../constants/networkConfig';

const NetworkIndicator = ({ provider }) => {
  const [networkName, setNetworkName] = useState('');
  const [isCorrectNetwork, setIsCorrectNetwork] = useState(true);
  
  useEffect(() => {
    const checkNetwork = async () => {
      if (!provider) {
        setNetworkName('Not Connected');
        setIsCorrectNetwork(false);
        return;
      }
      
      try {
        const network = await provider.getNetwork();
        setNetworkName(network.name === 'unknown' ? NETWORK_CONFIG.CHAIN_NAME : network.name);
        setIsCorrectNetwork(network.chainId === NETWORK_CONFIG.CHAIN_ID);
      } catch (error) {
        console.error("Error checking network:", error);
        setNetworkName('Error');
        setIsCorrectNetwork(false);
      }
    };
    
    checkNetwork();
  }, [provider]);
  
  const handleSwitchNetwork = async () => {
    const success = await requestNetworkSwitch();
    if (success) {
      // The page will reload due to chain change event
      console.log("Network switch initiated");
    }
  };
  
  return (
    <div className={`rounded-lg px-3 py-1 text-sm ${isCorrectNetwork ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
      <span className="flex items-center">
        <span className={`inline-block w-2 h-2 rounded-full mr-2 ${isCorrectNetwork ? 'bg-green-500' : 'bg-red-500'}`}></span>
        {networkName}
        {!isCorrectNetwork && (
          <button 
            onClick={handleSwitchNetwork}
            className="ml-2 text-xs bg-red-700 text-white px-2 py-1 rounded hover:bg-red-800"
          >
            Switch
          </button>
        )}
      </span>
    </div>
  );
};

export default NetworkIndicator;